/**
 * @enum FieldFetchType
 * @member STATIC is to use from static data returned from api
 */
enum FieldFetchType {
  STATIC = "STATIC",
  OPTION = "OPTION",
  API = "API"
}

export default FieldFetchType;
